import { FC, memo } from 'react';
import { useTranslation } from 'react-i18next';
// Import UI Components
import { Tooltip } from '@geneui/components';
// Import Constants
import { l } from 'constants/common';

interface Props {
    partners: {
        PartnerId: number;
        Name: string;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        [key: string]: any;
    }[];
}

const AdminProviderPartnersInfo: FC<Props> = ({ partners }) => {
    const { t } = useTranslation();

    const partnerIdName = (partners ?? []).map((partner) => `${partner.PartnerId} - ${partner.Name}`).join(', ');

    return (
        <Tooltip text={partnerIdName}>
            <span className="ellipsis-text">{partners?.length === 0 ? t(l.NA) : partnerIdName}</span>
        </Tooltip>
    );
};

export default memo(AdminProviderPartnersInfo);
